import axios from 'axios';
import log from 'lib/logger';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['notificationList', 'notificationIndicator', 'notificationCountLabel'];

  src = null;

  initialize() {
    this.observer = new IntersectionObserver(this.markAsRead.bind(this), { threshold: [1] });
  }

  notificationListTargetConnected(target) {
    this.observer.observe(target);
  }

  connect() {
    this.src = this.notificationListTarget.getAttribute('data-lazy-load-src-value');
  }

  notificationListTargetDisconnected(target) {
    this.observer?.unobserve(target);
  }

  async refreshMenu(event) {
    const count = event.detail ? event.detail.unreadCount : this.notificationListTarget.dataset.notificationCount;
    const unreadCount = count > 9 ? '9+' : count;

    if (count > 0) {
      this.notificationIndicatorTarget.classList.remove('d-none');
      this.notificationIndicatorTarget.classList.add('d-inline-block');
    } else {
      this.notificationIndicatorTarget.classList.add('d-none');
      this.notificationIndicatorTarget.classList.remove('d-inline-block');
    }

    this.notificationCountLabelTarget.textContent = `${unreadCount}`;
    this.updateLazyLoadSrc();
  }

  // Private

  async markAsRead(entries) {
    const lastEntry = entries.slice(-1)[0];
    if (!lastEntry?.isIntersecting) return;

    try {
      await axios.post('/lazy_load/notifications/mark_all_read');
      this.notificationIndicatorTarget.classList.add('d-none');
      this.notificationIndicatorTarget.classList.remove('d-inline-block');
      this.notificationCountLabelTarget.textContent = '0';
    } catch (error) {
      log.error(error);
    }
  }

  updateLazyLoadSrc() {
    if (!this.src) return;

    const url = new URL(this.src, window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('refetchTime', new Date().getTime());
    url.search = params.toString();

    this.notificationListTarget.setAttribute('data-lazy-load-src-value', url.toString());
  }
}
